import { useState } from 'react';
import { useForm, useFormContext } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PlanInterface, PlanFormValues, planFormSchema, ColorValue } from './PlanFormInfo.type';
import { FileProps } from '../../types';

export const BILLING_TRIGGER = [
  {
    label: 'Ao iniciar o plano (pré-pago)',
    value: 'inicio_do_periodo'
  },
  {
    label: 'Ao finalizar o plano (pós-pago)',
    value: 'fim_do_periodo'
  }
];

interface UsePlanFormInfoProps {
  initialPlan: PlanInterface;
  onPlanChange?: (plan: Partial<PlanInterface>) => void;
  onImageUpload?: (file: FileProps) => void;
}

export const usePlanFormInfo = ({ initialPlan, onPlanChange, onImageUpload }: UsePlanFormInfoProps) => {
  const [enabledColor, setEnabledColor] = useState(!!initialPlan?.color);

  const form = useFormContext<PlanFormValues>();
  const { setValue } = form;
  
  const handleColorChange = (color: ColorValue) => {
    setValue('color', color.hex);
  };
  
  const handleSwitchChange = () => {
    const newEnabledColor = !enabledColor;
    setEnabledColor(newEnabledColor);
    
    if (!newEnabledColor) {
      setValue('color', undefined);
    }
  };
  
  const handleImageUpload = (file: FileProps) => {
    setValue('coverUrl', file.preview || file.path || '');
    onImageUpload?.(file);
  };
  
  return {
    form,
    enabledColor,
    handleColorChange,
    handleSwitchChange,
    handleImageUpload,
    planInfo: {
      code: initialPlan?.code,
    },
  };
}; 